// Libs
import { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// Components, Layouts, Pages
// Others
import { StorageEnum } from '~/utils/enum/base';
import { RoleEnum } from '~/utils/enum/common';
import { authRouteAbsolute } from '~/utils/routes/auth';
// Styles, images, icons

type Props = {
  role: RoleEnum;
};

const ProtectedRoute = (props: Props) => {
  //#region Destructuring Props
  const { role } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isLoggedIn] = useState<string | null>(localStorage.getItem(StorageEnum.ACCESS_TOKEN)! || null);
  const [currentRole] = useState<string | null>(JSON.parse(localStorage.getItem(StorageEnum.ROLE)!)?.[0] || null);
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return isLoggedIn && currentRole === role ? <Outlet /> : <Navigate to={authRouteAbsolute.login} />;
};

export default ProtectedRoute;
